import React, { useState, SyntheticEvent } from 'react'
import ValueCard from '../../components/value-card'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import getUrl from 'lib/url'

const score_bg = require('static/score-bg.png')

const logo = require('static/dong-che-fen-logo.png')

const change_ic = require('static/change-ic.png')
const change_ic2 = require('static/change-ic@2x.png')
const change_ic3 = require('static/change-ic@3x.png')

export interface CarReview {
  series_id: number
  series_name: string
  author_info: {
    user_id: number
    user_name: string
    avatar_url: string
  }
  related_group_id: {
    group_count: number
    group_list: [string]
  }
  cover_url: string
  score: number
  content: string
  comfort_score: number
  appearance_score: number
  configuration_score: number
  control_score: number
  power_score: number
  space_score: number
  interiors_score: number
}
export default function DongCheFen({
  reviewData = [],
}: {
  reviewData: CarReview[]
}) {
  const [indexNext, setIndexNext] = useState(0)
  const onChangeClick = () => {
    setIndexNext((indexNext + 3) % reviewData.length)
  }

  const arr: CarReview[] =
    reviewData.length >= indexNext + 3
      ? reviewData.slice(indexNext, indexNext + 3)
      : reviewData
        .slice(indexNext)
        .concat(reviewData.slice(0, indexNext + 3 - reviewData.length))
  return (
    <div className="wrapper" id="dong_che_fen">
      <div className="container">
        <img className="background" src={score_bg} />
        <div className="top-bar">
          <img src={logo} className="logo" />
          <span className="text">每次评分都源自一次真实的体验</span>
          <span
            className="change-ic tw-flex tw-items-center"
            onClick={onChangeClick}
          >
            换一换
            <img src={change_ic} srcSet={`${change_ic2}, ${change_ic3}`} />
          </span>
        </div>
        <div className="card-wrapper">
          {arr.map(e => (
            <ValueCard {...e} key={e.series_id + e.author_info.user_id} />
          ))}
        </div>
      </div>
      <style jsx>
        {`
          .wrapper {
            padding-top: 40px;
          }
          .container {
            position: relative;
            width: 1196px;
            height: 304px;
            border-radius: 2px;
            background-image: linear-gradient(
              to bottom,
              #1f2129,
              #757582,
              #8a8c99
            );
            padding: 24px 16px 24px 17px;
          }
          .background {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .top-bar {
            display: flex;
            position: absolute;
            width: calc(100% - 32px);
            height: 34px;
            justify-content: flex-start;
            align-items: center;
          }
          .card-wrapper {
            position: absolute;
            top: 74px;
            left: 0;
            height: 206px;
            width: 100%;
          }
          .logo {
            width: 85px;
            height: 34px;
            object-fit: contain;
            margin-right: 21px;
          }
          .text {
            font-size: 16px;
            color: #979aa8;
          }
          .change-ic {
            font-size: 16px;
            color: white;
            justify-self: flex-end;
            margin-left: auto;
            cursor: pointer;
          }
          .change-ic img {
            width: 12px;
            height: 12px;
            object-fit: contain;
            margin-left: 4px;
          }
        `}
      </style>
    </div>
  )
}
